import { render, staticRenderFns } from "./Base700Black.vue?vue&type=template&id=a1062ab2&scoped=true&"
var script = {}
import style0 from "./Base700Black.vue?vue&type=style&index=0&id=a1062ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1062ab2",
  null
  
)

export default component.exports